import React from 'react';

import JobsListPage from '../../../js/pages/JobsListPage';
import fde from '../../../js/pages/JobsListPage/fdeJobs';

const Page = () => <JobsListPage role={fde} />;

export default Page;
